<template>
  <ls-table-layout>
    <div class="table-page-search-wrapper" slot="search">
      <a-form layout="inline" :labelCol="{ style: { width: '80px' } }">
        <a-row>
          <a-col :md="6" :sm="24">
            <a-form-item label="物料编码" class="itemcode">
              <a-input-group compact>
                <a-input v-model="queryParams.itemCode" />
              </a-input-group>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="来源分类">
              <a-select
                show-search
                option-filter-prop="children"
                v-model="queryParams.lookupValueList"
                mode="multiple"
                :max-tag-text-length="2"
                :max-tag-count="2"
                @change="uomClassOnChange">
                <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24">
            <a-form-item label="来源单位">
              <a-select
                show-search
                option-filter-prop="children"
                v-model="queryParams.unitOfMeasureList"
                mode="multiple"
                :max-tag-text-length="2"
                :max-tag-count="2">
                <a-select-option v-for="item in unitOfMeasureList" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="目标分类">
              <a-select
                v-model="queryParams.toLookupValueList"
                mode="multiple"
                :max-tag-text-length="2"
                :max-tag-count="1"
                @change="toLookupValueOnChange">
                <a-select-option v-for="(item) in uomClassOptions" :key="item.lookupCode">{{ item.lookupValue }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :md="6" :sm="24" v-if="advanced">
            <a-form-item label="目标单位">
              <a-select
                v-model="queryParams.toUnitOfMeasureList"
                mode="multiple"
                :max-tag-text-length="2"
                :max-tag-count="1">
                <a-select-option v-for="item in toUnitOfMeasureOptions" :key="item.key">{{ item.value }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="状态">
                <a-select v-model="queryParams.status" allowClear>
                  <a-select-option v-for="(item) in statusOptions" :key="item.dictValue">{{ item.dictLabel }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="6" :sm="24">
            <span class="table-page-search-submitButtons">
              <a-button @click="onSearch" type="primary">查询</a-button>
              <a-button @click="resetQuery" class="ml8">重置</a-button>
              <a @click="toggleAdvanced" class="ml8">
                {{ advanced ? '收起' : '展开' }}
                <a-icon :type="advanced ? 'up' : 'down'"/>
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>
    <div class="table-page-operator-wrapper" slot="btn">
      <download-modal :apiFun="apiMdmUomClassesNewExport" ref="download" />
      <a-button @click="$refs.createModal.show()" type="primary" v-hasPermi="['mdm:mdmUomClasses:add']">新增</a-button>
      <a-button @click="handleExport" v-hasPermi="['mdm:mdmUomClasses:export']">导出</a-button>
    </div>
    <template v-slot:table>
      <div class="page-header-content">
        <!-- 表格 -->
        <ls-api-table
          ref="dataTable"
          :columns="columns"
          :tableProps="tableProps"
          rowKey="id"
          :scroll="{ fixScreen: true, x: 1800 }"
          :toolBox="{
                density: true, // 传入String时 初始化默认表格密度
                fullScreen: false,  // 是否需要全屏
                configKey: $TableKey.CLASSIFICATION_UNIT_LIST, // 表格方案配置唯一值
              }"
        >
          <template slot="conversionRate" slot-scope="{ record }">
            <a-popover>
              <template slot="content">
                <p>即换算比例，1*折换*来源单位=1*基本单位</p>
              </template>
              <span v-if="!isEdit || currentId !== record.id">{{ record.conversionRate }}</span>
              <a-input-number v-if="isEdit && currentId === record.id" v-model="record.conversionRate" :min="0" size="small" @blur="blur(record)" />
            </a-popover>
          </template>
          <template slot="conversionRateInverse" slot-scope="{ record }">
            <a-popover>
              <template slot="content">
                <p>即换算比例倒数，1*倒数*来源单位=1*基本单位</p>
              </template>
              <span>{{ record.conversionRateInverse }}</span>
            </a-popover>
          </template>
          <template slot="updateTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="createTime" slot-scope="{ text }">
            <span>{{ text && $moment(text).format('YYYY-MM-DD HH:mm') }}</span>
          </template>
          <template slot="status" slot-scope="{ record }">
            <a-switch :disabled="!isEdit || currentId !== record.id" :checked="record.status === 'Y'" @change="statusOnChange(record)" />
          </template>
          <!-- 操作 -->
          <span slot="operation" slot-scope="{ record }">
            <a v-if="!isEdit || currentId !== record.id" @click="handleEdit(record)" v-hasPermi="['mdm:mdmUomClasses:edit']">编辑</a>
            <a v-if="isEdit && currentId === record.id" @click="handleSave(record)">保存</a>
            <a v-if="isEdit && currentId === record.id" @click="handleCancel(record)" class="ml10">取消</a>
          </span>
        </ls-api-table>

        <!-- 底部分页按钮 -->
        <!-- <Page ref="page" :pageParams.sync="pageParams" @getList="getList" /> -->
        <!-- 创建/编辑快码,单独封装了组件 -->
        <classification-unit-add
          ref="createModal"
          @handle-success="handleOk"
        />
      </div>
    </template>
  </ls-table-layout>
</template>

<script>
import { apiMdmUomClassesUpdate, apiMdmUomUnitsOfMeasureUnitOfMeasureList, apiMdmUomClassesList, apiMdmUomClassesNewExport } from '@/api/mdm/units/classification-unit'
import ClassificationUnitAdd from './components/classification-unit-add'
import { generateLsTableResData } from '@/utils/util.js';
import DownloadModal from '@/views/components/download-modal/download-modal.vue'

export default {
  name: 'ClassificationUnit',
  components: {
    DownloadModal,
    ClassificationUnitAdd
  },
  data () {
    return {
       apiMdmUomClassesNewExport,
       // 表格配置
       tableProps: {
        requestApi: generateLsTableResData(apiMdmUomClassesList, true),
        pageCurrent: true
      },
      pageParams: {
        automatic: true,
        pageUrl: '/mdm/mdmUomClasses/list',
        tableLoading: false
      },
      isEdit: false,
      currentId: "",
      // 控制搜索展开
      advanced: true,
      // 查询参数
      queryParams: {
        staItemCode: undefined,
        endItemCode: undefined,
        lookupValueList: undefined,
        unitOfMeasureList: undefined,
        toLookupValueList: undefined,
        toUnitOfMeasureList: undefined,
        status: undefined
      },
      // 状态快码
      statusOptions: [
        {
          dictLabel: "有效",
          dictValue: "Y"
        },
        {
          dictLabel: "无效",
          dictValue: "N"
        }
      ],
      baseUomFlagOptions: [
        {
          dictLabel: "是",
          dictValue: "Y"
        },
        {
          dictLabel: "否",
          dictValue: "N"
        }
      ],
      // 快码表格数据
      typeList: [],
      // 表格字段
      columns: [
        {
          title: '物料编码',
          dataIndex: 'itemCode',
          width: 160,
          align: 'center'
        },
        {
          title: '来源单位',
          dataIndex: 'unitOfMeasure',
          ellipsis: true,
          width: 120,
          align: 'center'
        },
        {
          title: '来源分类',
          dataIndex: 'lookupValue',
          width: 120,
          align: 'center'
        },
        {
          title: '折换',
          dataIndex: 'conversionRate',
          width: 120,
          scopedSlots: { customRender: 'conversionRate' },
          align: 'center'
        },
        {
          title: '倒数',
          dataIndex: 'conversionRateInverse',
          scopedSlots: { customRender: 'conversionRateInverse' },
          ellipsis: true,
          align: 'center'
        },
        {
          title: '目标单位',
          dataIndex: 'toUnitOfMeasure',
          align: 'center'
        },
        {
          title: '目标分类',
          dataIndex: 'toLookupValue',
          align: 'center'
        },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'status' },
          align: 'center'
        },
        {
          title: '最后修改人',
          dataIndex: 'updateName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '最后修改时间',
          dataIndex: 'updateTime',
          scopedSlots: { customRender: 'updateTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '创建人',
          dataIndex: 'createName',
          ellipsis: true,
          align: 'center'
        },
        {
          title: '创建时间',
          dataIndex: 'createTime',
          scopedSlots: { customRender: 'createTime' },
          width: 150,
          align: 'center'
        },
        {
          title: '操作',
          width: 100,
          dataIndex: 'operation',
          scopedSlots: { customRender: 'operation' },
          stickyFixed: 'right'
        }
      ],
      // 表格多选
      selectedRowKeys: [],
      selectedRows: [],
      rowSelection: {
        onChange: (selectedRowKeys, selectedRows) => {
          this.selectedRowKeys = selectedRowKeys
          this.selectedRows = selectedRows
        },
        onSelect: (record, selected, selectedRows) => {},
        onSelectAll: (selected, selectedRows, changeRows) => {}
      },
      uomClassOptions: [], // 来源分类、目标分类
      unitOfMeasureList: [], // 来源单位
      toUnitOfMeasureOptions: [] // 目标单位
    }
  },
  created () {
    this.getUnitOfMeasureList()
    this.getToUnitOfMeasureList()

    this.getLookupList('MDM_UOM_CLASSES', 'uomClassOptions')
  },
  mounted () {
    // this.onSearch()
  },
  methods: {
    // 表单搜索
    onSearch () {
      this.isEdit = false
      this.$refs.dataTable.searchParams = this.queryParams;
      this.$refs.dataTable.getData();
    },
    getLookupList (type, arr) {
      const lookupQueryParams = {
        lookupType: type,
        current: 1,
        pageSize: 100
      }
      this.getLookupListData(lookupQueryParams).then().then(response => {
        this[arr] = response.rows
      })
    },
    // 来源分类
    uomClassOnChange () {
      this.getUnitOfMeasureList()
    },
    // 目标分类
    toLookupValueOnChange () {
      this.getToUnitOfMeasureList()
    },
    // 物料范围-开始
    staItemCodeOnChange (val) {
      this.queryParams.staItemCode = val
      if (!this.queryParams.endItemCode) {
        this.queryParams.endItemCode = val
      }
    },
    // 物料范围-结束
    endItemCodeOnChange (val) {
      this.queryParams.endItemCode = val
      if (!this.queryParams.staItemCode) {
        this.queryParams.staItemCode = val
      }
    },
    // 列表-折换字段
    blur (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
      } else {
        record.conversionRateInverse = this.$countBackwards(Number(record.conversionRate))
      }
    },
    statusOnChange (record) {
      record.status = record.status === 'Y' ? 'N' : 'Y'
    },
    // 导入导出excel
    /** 导出按钮操作 */
    handleExport () {
      const params = this.queryParams
      this.$refs.download.openModal(params)
      // this.download('mdm/mdmUomClasses/export', {
      //   ...this.queryParams
      // }, `分类单位转换_${new Date().getTime()}.xlsx`)
    },
    // 来源单位-下拉框数据
    getUnitOfMeasureList () {
      this.queryParams.unitOfMeasureList = undefined
      const params = {
        uomClassList: this.queryParams.lookupValueList
      }
      apiMdmUomUnitsOfMeasureUnitOfMeasureList(params).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label
            }
            list.push(obj)
          });
          this.unitOfMeasureList = list
        }
      })
    },
    // 目标单位-下拉框数据
    getToUnitOfMeasureList () {
      this.queryParams.toUnitOfMeasureList = undefined
      const params = {
        uomClassList: this.queryParams.toLookupValueList
      }
      apiMdmUomUnitsOfMeasureUnitOfMeasureList(params).then(res => {
        if (res.code === 200 && res.data && res.data.length > 0) {
          const arr = res.data;
          const list = [];
          arr.forEach(element => {
            const obj = {
              key: element.realValue,
              value: element.label
            }
            list.push(obj)
          });
          this.toUnitOfMeasureOptions = list
        }
      })
    },
    // 编辑
    handleEdit (record) {
      if (this.currentId && record.id !== this.currentId && this.isEdit) {
        this.$message.warning('请保存上次编辑的数据')
        return;
      }
      this.isEdit = true;
      this.currentId = record.id;
    },
    // 编辑-保存
    handleSave (record) {
      if (!record.conversionRate || Number(record.conversionRate) <= 0) {
        this.$message.warning('折换不能为空且需大于0')
        return
      }
      apiMdmUomClassesUpdate(record).then(response => {
        if (response.code === 200) {
          this.$message.success('保存成功')
          this.onSearch()
          this.isEdit = false;
        } else {
          this.$message.error(response.msg)
        }
      })
    },
    // 取消
    handleCancel (record) {
      this.isEdit = false
      this.onSearch()
    },
    /** 查询列表 */
    getList (data) {
      this.typeList = data
    },
    // 新增/修改框事件
    handleOk () {
      this.onSearch()
    },
    /** 重置按钮操作 */
    resetQuery () {
      this.queryParams = {
        staItemCode: undefined,
        endItemCode: undefined,
        lookupValueList: undefined,
        unitOfMeasureList: undefined,
        toLookupValueList: undefined,
        toUnitOfMeasureList: undefined,
        status: undefined
      }
      this.onSearch()
    },
    // 搜索框展开、收起
    toggleAdvanced () {
      this.advanced = !this.advanced
    }
  }
}
</script>

<style scoped lang="less">
.ml10{
  margin-left: 10px;
}
.itemcode{
  /deep/.ant-select{
    display: unset;
  }
  /deep/.ant-input-group.ant-input-group-compact {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .item-code-select {
    // width: 48% !important;
    flex: 1;
  }
  .item-code-select-separator {
    margin: 0 5px;
  }
}
</style>
